/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Device } from '../../models/device';

export interface ApiMasterDeviceGetActiveGet$Params {
}

export function apiMasterDeviceGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterDeviceGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Device>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterDeviceGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Device>>;
    })
  );
}

apiMasterDeviceGetActiveGet.PATH = '/api/Master/Device/GetActive';
